import React, { useEffect } from 'react'
import { css } from '@emotion/core'
import * as ReportModel from '@/models/report'
import { FormContainer, FormInputBlock, FormInputRadioWrapper } from '@/components/molecules/reports-manager/form-container'
import { Select } from '@/components/atoms/select'
import { Select as AntSelect } from 'antd'
import { Controller, UseFormReturn, useWatch } from 'react-hook-form'
import { SalesMonthCascader } from '@/components/molecules/reports-manager/sales-month-cascader'
import { ReportFormType } from '@/features/report-manager/report-manager-slice'

export const YearlyReportForm: React.FC<{ formReturn: UseFormReturn<ReportFormType, any> }> = props => {
  const { control, handleSubmit, setValue } = props.formReturn
  const watchType = useWatch({ control, name: 'type' })

  useEffect(() => {
    if (!ReportModel.yearlyReportTypes.includes(watchType)) {
      setValue('type', ReportModel.yearlyReportTypes[0])
    }
  }, [])

  return (
    <FormContainer onSubmit={handleSubmit}>
      <FormInputBlock title="レポート種類">
        <Controller
          name="type"
          control={control}
          render={({ field: { onChange, value } }) => (
            <Select value={value} onChange={onChange} customStyle={css({ paddingBottom: 0, width: 290 })}>
              {ReportModel.yearlyReportTypes.map(type => (
                <AntSelect.Option key={type} value={type}>
                  {ReportModel.ReportTypeNames[type]}
                </AntSelect.Option>
              ))}
            </Select>
          )}
        />
      </FormInputBlock>

      <FormInputBlock title="対象月">
        <Controller
          name="month"
          control={control}
          render={({ field: { onChange, value } }) => (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14 }}>
              <SalesMonthCascader onChange={onChange} value={value} />
              <p>までの2年間の集計比較</p>
            </div>
          )}
        />
      </FormInputBlock>

      <FormInputBlock title="出力形式">
        <Controller
          name="format"
          control={control}
          render={({ field: { onChange, value } }) => (
            <FormInputRadioWrapper value={value} items={ReportModel.formatRadioItems} onChange={onChange} />
          )}
        />
      </FormInputBlock>

      <FormInputBlock title="税表示">
        <Controller
          name="isIncludeTax"
          control={control}
          render={({ field: { onChange, value } }) => (
            <FormInputRadioWrapper value={value} items={ReportModel.taxRadioItems} onChange={onChange} />
          )}
        />
      </FormInputBlock>
    </FormContainer>
  )
}
